import { render, staticRenderFns } from "./TestRecords.vue?vue&type=template&id=fdedd616&scoped=true"
import script from "./TestRecords.vue?vue&type=script&lang=js"
export * from "./TestRecords.vue?vue&type=script&lang=js"
import style0 from "./TestRecords.vue?vue&type=style&index=0&id=fdedd616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdedd616",
  null
  
)

export default component.exports